module.exports = __webpack_public_path__ + "img/instanteft.e983d9a2.png";